import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    FindWarehouseData,
} from "@insite/client-framework/Store/Data/RealTimeInventory/Handlers/GetRealTimeWarehouseInventory";
import { WarehouseDto } from "@insite/client-framework/Types/ApiModels";

export interface Result {
    errorMessage: string;
    warehouses?: WarehouseDto[];
    additionalResults?: any; // Store Custom Code
}

addToChainAfter(chain, FindWarehouseData, props => {
    if (props.apiResult && props.apiResult.additionalResults) {
        if (!props.result) {
            props.result = { errorMessage: "" };
        }
        (props.result as Result).additionalResults = props.apiResult.additionalResults;
    }
});
